<template>
  <div class="myCenter-right">
    <h3 class="title">{{$t('MyCenter.currentBaby')}}</h3>
    <div class="baby-list clearFloat">
      <div
        class="item"
        v-for="(item,index) of childList"
        :key="index"
        :class="{'border1':item.default}"
        @click.stop="clickChild(item,index)"
      >
        <div class="img">
          <img v-if="item.student_img !=''" :src="item.student_img" alt />
          <img
            v-else-if="item.student_img =='' && item.student_sex ==$t('Common.woman')"
            src="@/assets/images/childWoman.png"
            alt
          />
          <img
            v-else-if="item.student_img =='' && item.student_sex ==$t('Common.man')"
            src="@/assets/images/childMan.png"
            alt
          />
          <img
            v-else-if="item.student_img =='' && item.student_sex ==''"
            src="@/assets/images/childImg.png"
            alt
          />
        </div>
        <p class="one">
          {{item.student_cnname}}
          <img
            v-if="item.student_sex == $t('Common.man')"
            src="@/assets/images/myCenter/man.png"
            alt
          />
          <img v-if="item.student_sex == $t('Common.woman')" src="@/assets/images/myCenter/woman.png" alt />
        </p>

        <p class="two">{{item.class_cnname}}</p>
        <span class="Select SelectChild" :class="{'SelectChildCur':item.default}"></span>
        <!-- <span
          class="delete deleteChild"
          :class="{'deleteChildCur':item.default}"
          @click.stop="handleDelete"
        ></span>-->
      </div>
    </div>
    <h3 class="title">{{$t('MyCenter.currentBabyInfo')}}</h3>
    <div class="baby-info">
      <ul>
        <li>
          <span>{{$t('MyCenter.schoolName')}}</span>
          <span>{{currentChild.school_cnname}}</span>
        </li>
        <li>
          <span>{{$t('MyCenter.className')}}</span>
          <span>{{currentChild.class_cnname}}</span>
        </li>
        <li>
          <span>{{$t('MyCenter.brand')}}</span>
          <span>{{currentChild.class_branch}}</span>
        </li>
        <li>
          <span>{{$t('MyCenter.code')}}</span>
          <span>{{currentChild.classcode_name}}</span>
        </li>
        <li>
          <span>{{$t('MyCenter.birthday')}}</span>
          <span>{{currentChild.student_birthday}}</span>
        </li>
      </ul>
    </div>
    <div class="action">
      <button class="btn bg-base" @click="loginQuit">{{$t('Common.quitLogin')}}</button>
    </div>
    <!-- 删除孩子 弹窗 -->
    <!-- <popTips
      :dialogVisable="closeItem"
      :popTipsCont="popTips_close"
      @handConfirm="closeItem=false"
      @handCancel="closeItem=false"
      @handleCloseTip="closeItem=false"
    ></popTips>-->

    <!-- 切换孩子 弹窗 -->
    <div class="Poplayer-box" v-if="verify.dialogVisable">
      <div class="changeChildProp">
        <div class="close" @click="closeChangeChild">
          <img src="../../../assets/images/close.png" alt />
        </div>
        <div class="tabs-box">
          <div class="tabs">
            <span :class="verify.flag?'changePsw-base':''" @click="changePsw(0)">{{$t('MyCenter.pswChange')}}</span>
            <span @click="changePsw(1)" :class="!verify.flag?'changePsw-base':''">{{$t('MyCenter.verifty')}}</span>
          </div>
          <div class="bindPhone">{{$t('MyCenter.band')}} {{verify.account1}}</div>
          <div class="verify-psw" v-if="verify.flag">
            <input type="password" class="ipt" v-model="verify.psw" :placeholder="$t('MyCenter.pswHD')" />
          </div>
          <div class="verify-num" v-if="!verify.flag">
            <input type="number" v-model="verify.num" :placeholder="$t('MyCenter.veriftyHD')" class="ipt" />
            <span class="getCode bg-base" v-if="canGetCode" @click="getCode">{{getCodeTxt}}</span>
            <span class="getCode" v-else style="background:#aaa;" @click="getCode">{{ leftTime }}s</span>
          </div>
          <div
            class="changebaby bg-base cursor"
            v-if="verify.flag"
            @click="changeChildConfrim(0)"
          >{{$t('MyCenter.changeBaby')}}</div>
          <div class="changebaby bg-base cursor" v-else @click="changeChildConfrim(1)">{{$t('MyCenter.changeBaby')}}</div>
        </div>
      </div>
    </div>
    <!-- 退出 弹窗 -->
    <popTips
      :dialogVisable="quitItem"
      :popTipsCont="popTips_quit"
      @handConfirm="handQuitConfirm"
      @handCancel="quitItem=false"
      @handleCloseTip="quitItem=false"
    ></popTips>
    <message :message="message" :showTip="showTip" @hideTip="hideTip" />
    <PageLoading :active="isActive" />
  </div>
</template>

<script>
import message from "@/components/Common/message";
import myCenterStore from "@/views/myCenter/myCenter";
import popTips from "@/components/popTips";
import PageLoading from "@/components/Loading";
import Api from "@/views/Home/indexApi";
// import sideBar from "../../components/MyCenter/sideBar"
export default {
  name: "mine",
  components: {
    popTips,
    message,
    PageLoading
    // sideBar
  },
  data() {
    return {
      isActive: false,
      token: "",
      member_id: "",
      message: "",
      showTip: false,
      //孩子信息列表
      childList: [],
      currentChild: {}, //当前孩子信息
      quitItem: false, //删除孩子
      // 退出登录 - 提示弹窗
      popTips_quit: {
        // btn_text1: "确定删除",
        // btn_text2: "我在想想",
        title: this.$t('Common.tips'),
        context: this.$t('Common.quitAccount'),
        btns: [
          {
            text: this.$t('Common.confirmQuit'),
            event: "handConfirm"
          },
          {
            text: this.$t('Common.think'),
            event: "handCancel"
          }
        ]
      },
      //切换孩子
      verify: {
        dialogVisable: false, //切换孩子弹窗是否显示
        account: "", //切换孩子 - 账号
        account1:'', //切换孩子 - 账号 - ****隐藏中间四位
        student_id: "", //学生id
        index: 0, //当前选中的孩子
        psw: "", //请输入密码
        num: "", //请输入验证码
        flag: true //切换 - 标识
      },
      getCodeTxt: this.$t('MyCenter.getCode'),
      canGetCode: true,
      leftTime: 60
    };
  },
  mounted() {},
  updated() {},
  created() {
    this.childList = this.$Tool.getStorage("childList");
    this.currentChild = this.$Tool.getStorage("currentStuInfo");
    let timeStr = this.currentChild.student_birthday;
    this.currentChild.student_birthday =
      timeStr.slice(0, 4) +
      "-" +
      timeStr.slice(4, 6) +
      "-" +
      timeStr.slice(6, 8);
    this.token = this.$store.state.token;
    this.member_id = this.$store.state.member_id;
    console.log(this.$store.state.token);
    console.log(this.$store.state.member_id);
    this.isActive = true;
    this.getAllStudents(); //获取所有的孩子
    console.log(this.$Tool.getStorage("account"));
    this.verify.account = this.$Tool.getStorage("account"); //切换孩子 - 账号
    this.verify.account1 = this.geTel(this.verify.account)
    console.log(this.$Tool.getStorage("rember"));
  },
  watch: {},
  computed: {},
  methods: {
    geTel(tel){
      return tel.substring(0, 3)+"****"+tel.substr(tel.length-4);
    },
    hideTip() {
      this.showTip = false;
    },
    //获取全部孩子-接口
    getAllStudents() {
      myCenterStore
        .getAllStudents({
          token: this.token, //登陆获取token
          member_id: this.member_id //登陆获取的会员表
        })
        .then(res => {
          if (res.data.error == 0) {
            this.isActive = false;
            let studentInfo = res.data.result.list;
            this.childList = [...studentInfo];

            if (this.currentChild) {
              let isSame = false;
              this.childList.forEach((item, i) => {
                this.childList[i].default = false;
                if (
                  item.student_id == this.$store.state.currentChild.student_id
                ) {
                  this.childList[i].default = true;
                  this.currentChild = Object.assign({}, item);
                  isSame = true;
                }
              });
              if (!isSame) {
                this.currentChild = this.childList[0];
              }
              let timeStr = this.currentChild.student_birthday;
              this.currentChild.student_birthday =
                timeStr.slice(0, 4) +
                "-" +
                timeStr.slice(4, 6) +
                "-" +
                timeStr.slice(6, 8);
            } else {
              this.currentChild = studentInfo[0];
              let timeStr = this.currentChild.student_birthday;
              this.currentChild.student_birthday =
                timeStr.slice(0, 4) +
                "-" +
                timeStr.slice(4, 6) +
                "-" +
                timeStr.slice(6, 8);
              this.childList.forEach((element, index1) => {
                this.childList[index1].default = false;
                this.childList[0].default = true;
              });
            }

            this.$Tool.setStorage("childList", this.childList); //当前学生的个人信息
            this.$Tool.setStorage("currentStuInfo", this.currentChild); //当前学生的个人信息
            this.$store.dispatch("setCurrentChild", this.currentChild);
            this.getNodonums();
          } else {
            this.isActive = false;
          }
        });
    },

    //密码 和 验证码 切换
    changePsw(val) {
      if (val == 0) {
        //密码
        this.verify.flag = true;
      } else if (val == 1) {
        //验证码
        this.verify.flag = false;
      }
      console.log(val);
    },
    //选择孩子 - 关闭 弹窗
    closeChangeChild() {
      let indexs = this.verify.index;
      this.verify.psw = "";
      this.verify.num = "";
      this.childList.forEach((element, index1) => {
        this.childList[indexs].default = false;
        if (element.student_id == this.currentChild.student_id) {
          this.childList[index1].default = true;
        }
      });
      this.verify.dialogVisable = !this.verify.dialogVisable;
    },
    //切换孩子
    clickChild(item, index) {
      console.log(item, index);
      this.verify.psw = "";
      this.verify.num = "";
      this.verify.index = index;
      this.verify.student_id = item.student_id;
      this.childList.forEach((element, index1) => {
        this.childList[index1].default = false;
        if (item.student_id != this.currentChild.student_id) {
          this.childList[index].default = true;
        }
      });
      if (
        this.childList.length > 1 &&
        item.student_id != this.currentChild.student_id
      ) {
        this.verify.dialogVisable = !this.verify.dialogVisable;
      }
    },
    // //删除孩子 - 点击
    // handleDelete() {
    //   this.closeItem = !this.closeItem;
    // },
    //按照账号 - 切换孩子
    Switch() {
      myCenterStore
        .Switch({
          ptcmobile: this.verify.account, //手机号
          ptcpswd: this.verify.psw //密码
        })
        .then(res => {
          if (res.data.error == 0) {
            this.getOneStudent();
            // this.verify.dialogVisable = !this.verify.dialogVisable;
          }
          this.message = res.data.errortip;
          this.showTip = true;
        });
    },
    //获取单个孩子 - 接口
    getOneStudent() {
      myCenterStore
        .getOneStudent({
          token: this.token, //登陆获取token
          member_id: this.member_id, //登陆获取的会员表
          student_id: this.verify.student_id //学生id
        })
        .then(res => {
          if (res.data.error == 0) {
            let studentInfo = res.data.result.list;
            let ArrayList = [];
            ArrayList.push(studentInfo);

            // this.childList = ArrayList;
            this.currentChild = studentInfo;
            let timeStr = this.currentChild.student_birthday;
            this.currentChild.student_birthday =
              timeStr.slice(0, 4) +
              "-" +
              timeStr.slice(4, 6) +
              "-" +
              timeStr.slice(6, 8);
            this.$Tool.setStorage("currentStuInfo", this.currentChild); //当前学生的个人信息
            this.$store.dispatch("setCurrentChild", this.currentChild);
            this.getNodonums();
          }
          window.location.href = '/home'
        });
    },
    //点击 获取 验证码
    getCode() {
      if(this.canGetCode){
        this.getSwitchBabyCode();
      }
    },
    //获取 验证码
    getSwitchBabyCode() {
      myCenterStore
        .getSwitchBabyCode({
          ptcmobile: this.verify.account //手机号码
        })
        .then(res => {
          this.message = res.data.errortip;
          this.showTip = true;
          if (res.data.error == 0) {
            this.canGetCode = false;
            let timer = setInterval(() => {
              if (this.leftTime > 0) {
                --this.leftTime;
              } else {
                clearInterval(timer);
                this.getCodeTxt =  this.$t('MyCenter.againget');
                this.canGetCode = true;
                this.leftTime = 60;
              }
            }, 1000);
          }
        });
    },
    //验证码 登录
    isTrueofSwitchBabyCode() {
      myCenterStore
        .isTrueofSwitchBabyCode({
          ptcmobile: this.verify.account, //手机号码
          ptccode: this.verify.num //验证码
        })
        .then(res => {
          if (res.data.error == 0) {
            this.getOneStudent();
            // this.verify.dialogVisable = !this.verify.dialogVisable;
          }
          this.message = res.data.errortip;
          this.showTip = true;
        });
    },
    //切换孩子 - 提交
    changeChildConfrim(val) {
      console.log(val)
      if (val == 0) {
        //按照账号 - 切换孩子
        if(this.verify.psw==''){
          this.message = this.$t('MyCenter.pswTips');
          this.showTip = true;
        }else{
          this.Switch();
        }
      } else if (val == 1) {
        //按照验证码 - 切换孩子
        this.isTrueofSwitchBabyCode();
        console.log(111);
      }
    },
    getNodonums() {
      Api.getNodonums({
        student_id: this.$store.state.currentChild.student_id,
        member_id: this.$store.state.member_id,
        token: this.$store.state.token
      }).then(res => {
        const { list } = res.data.result
        this.has_num = list.has_num
        this.undonenums = list.undonenums;
        this.$Tool.setStorage("undonenums", this.undonenums);
        this.$store.dispatch("setundonenums", this.undonenums);
        this.$Tool.setStorage("has_num", this.has_num);
        this.$store.dispatch("sethas_num", this.has_num);
      });
    },
    //退出登录
    loginQuit() {
      this.quitItem = true;
    },
    handQuitConfirm() {
      this.$router.push({ path: "/login" });
      this.message = this.$t('Common.quitLogin');
      this.showTip = true;
      this.$Tool.removeStorage("token");
      this.$Tool.removeStorage("member_id");
      // this.$Tool.removeStorage("isPlay");
      this.$store.dispatch("setUserToken", "");
      this.$store.dispatch("setMemberId", "");

      this.$Tool.setStorage("isPlay", false);
      this.$store.dispatch("setbgMusic", false);
      if (!this.$Tool.getStorage("rember")) {
        this.$Tool.setStorage("psw", ""); //密码
        this.$Tool.setStorage("account", ""); //账号
      }
      this.$Tool.removeStorage("rewordConfrim");
    }
  }
};
</script>

<style lang="less">
@import url("../myCenter");
.item {
  cursor: pointer;
}
</style>
